import React from 'react';
import NavigationBar from '../../components/navbar/component'
import Head from '../../components/head/component'
import Image from '../../image/OurTeamCover.png'
import {
    Footer
} from '../../components/footer/components'
import { Box } from 'reflexbox'
import Email from '../../image/email.png'
import Linkedin from '../../image/linkedin.png'
import { 
    Wrapper,
    NameDivBox,
    BodyBox,
    ImageDiv,
    Section,
    Title,
    Description,
    SendEmailButton,
    LinkedinButton,
    ButtonContainer,
    BoxImage,
    BGColor,
    Associate,
    AssociateTitle,
    AssociateBody,
    AssociateName
 } from './style'
import Profile1 from '../../image/profile1.png'
import Profile2 from '../../image/profile2.png'
import Profile3 from '../../image/profile3.png'
import { useTranslation } from 'react-i18next'
// import Star from '../../image/Star.png'

export const OurTeam = () => {
    const { t } = useTranslation('common');

    const data = [
        {
            name: "AGUST DOLOKSARIBU",
            title: "Managing Partner of Sequoia Advocates",
            description: t('ourTeam.description1'),
            image: Profile1,
            bgColor: "#9A302C",
            linkedin: "https://linkedin.com/in/agust-doloksaribu-ba817849",
            email: "doloksaribu@sequoiaadvocates.com"
        },
        {
            name: "HISAR JOHANNES",
            title: "Partner of Sequoia Advocates",
            description: t('ourTeam.description3'),
            image: Profile2,
            bgColor: "#56A6A7",
            linkedin: "https://www.linkedin.com/in/hisar-johannes-13526121b/",
            email: "hisar.johannes@sequoiaadvocates.com"
        },
        {
            name: "RANDOLPH YOSUA SIAGIAN",
            title: "Partner of Sequoia Advocates",
            description: t('ourTeam.description2'),
            image: Profile3,
            bgColor: "#255371",
            linkedin: "https://linkedin.com/in/randolph-yosua-siagian-213144ba",
            email: "randolph.yosua@sequoiaadvocates.com"
        }
    ]


    return (
        <Section>
            <NavigationBar />
            <Head 
                imagePath={Image}
                caption='YOUR SUPREME LEGAL PROTECTION'
            />
            <BGColor>
                {data.map((user) => (
                    <Wrapper>
                        <BoxImage>
                            <ImageDiv 
                                src={user.image} 
                            />
                            {/* <WhiteCircle>
                                <YellowCircle>
                                    <img src={Star} alt="star" />
                                </YellowCircle>
                            </WhiteCircle> */}
                        </BoxImage>
                        <NameDivBox>
                            {user.name}
                        </NameDivBox>
                        <BodyBox backgroundColor={user.bgColor}>
                            <Title>
                                {user.title}
                            </Title>
                            <Description>
                                {user.description}
                            </Description>
                            <ButtonContainer>
                                <SendEmailButton onClick={() => window.open(`mailto:${user.email}`, '_blank')}>
                                    <img 
                                        src={Email} 
                                        alt=""
                                        width="28px" 
                                        height="auto"
                                    />
                                    <Box 
                                        marginLeft='16px'
                                    >
                                        {t('introducing.sendEmail')}
                                    </Box>
                                </SendEmailButton>
                                <LinkedinButton onClick={() => window.open(user.linkedin, '_blank')}>
                                    <div>
                                        <img 
                                            src={Linkedin} 
                                            alt=""
                                            width="26px"
                                            height="auto"
                                        />
                                    </div>
                                    <Box 
                                        marginLeft='16px'
                                    >
                                        {t('introducing.connect')}
                                    </Box>
                                </LinkedinButton>
                            </ButtonContainer>
                        </BodyBox>
                    </Wrapper>
                ))}
            </BGColor>
            <Associate>
                <AssociateTitle>
                    ASSOCIATE
                </AssociateTitle>
                <AssociateBody>
                    <AssociateName>
                        Ezra Agustinus Doloksaribu
                    </AssociateName>
                    <AssociateName>
                        Steven Hadylaya
                    </AssociateName>
                </AssociateBody>
            </Associate>
            <Footer />
        </Section>
    )
}